import React from "react";

import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import { LiveWidgetTypes } from "@data-types/live-widget/LiveWidgetTypes";
import {
	LiveStreamConfigSideWidget,
	LiveStreamConfigWeb,
	LiveWidgetContainer,
} from "@features/live-widgets/shared";
import { useLiveWidgetStore } from "@state/hooks/live-widgets";
import { LiveStreamWidget } from "@state/stores/live-widgets/LiveStreamWidget";
import LmtLsEventStore from "@state/stores/side-widgets/LmtLsEventStore";
import { observer } from "mobx-react";

import { EventSelectorView } from ".";
import { TSideWidgetView } from "../../TSideWidgetView";

export const SideWidgetBody = observer(
	(props: {
		view: TSideWidgetView;
		setView: (newView: TSideWidgetView) => void;
		lmtLsEventStore: LmtLsEventStore;
	}) => {
		const store = useLiveWidgetStore();

		React.useEffect(() => {
			if (
				store.activeSideWidget == null &&
				props.view !== TSideWidgetView.EVENT_LIST
			) {
				props.setView(TSideWidgetView.EVENT_LIST);
			}
		}, [props.view, store.activeSideWidget]);

		if (store.isSideWidgetCollapsed) {
			return null;
		}

		switch (props.view) {
			case TSideWidgetView.LIVE_MATCH_TRACKER:
			case TSideWidgetView.LIVE_STREAM:
				return (
					<LiveWidgetContainer
						eventId={store.activeSideWidget?.eventId || ""}
						location={WidgetLocation.SIDE}
						lmtProps={{
							divProps: {
								className:
									"widget--stream widget--stream--borderless",
							},
						}}
						lsProps={{
							divProps: {
								className:
									"widget--stream widget--stream--borderless is-live",
							},
							config:
						store.activeSideWidget?.type === LiveWidgetTypes.LS &&
						(store.activeSideWidget as LiveStreamWidget)
							.isUserInitiated
							? LiveStreamConfigWeb
							: LiveStreamConfigSideWidget,
						}}
					/>
				);
			case TSideWidgetView.EVENT_LIST:
			default:
				return <EventSelectorView lmtLsStore={props.lmtLsEventStore} />;
		}
	}
);
